import * as Lucide from "lucide-react";

// Renderizza dinamicamente un'icona lucide dal nome salvato sulla sorgente ticket.
export function SourceIcon({ name, size = 14, className = "" }) {
  const Ico = (name && Lucide[name]) || Lucide.Circle;
  return <Ico size={size} className={className} aria-hidden />;
}
